<template>
  <AlertBanner
    :status="helperStatus.Warn"
    :inline-banner="true"
    :auto-scroll-to-banner="false"
    data-testid="message-email-verification-composer-banner"
  >
    <template #icon>
      <LockIcon :width="20" :height="20" color="#644900" />
    </template>
    <span class="text-body">
      Verify your email to send your message.
      <button
        type="button"
        class="ml-4 uppercase underline font-medium text-brand-contrast"
        data-testid="message-email-verification-cta"
        @click="$emit('verify')"
      >
        Verify your email
      </button>
    </span>
  </AlertBanner>
</template>

<script lang="ts">
import AlertBanner from '@/components/alert_banner/AlertBanner.vue';
import helperStatus from '@/helpers/status';
import LockIcon from '@/graphics/icons/LockIcon.vue';

export default {
  name: 'MessageEmailVerificationComposerBanner',
  components: {
    AlertBanner,
    LockIcon,
  },
  emits: ['verify'],
  setup() {
    return { helperStatus };
  },
};
</script>
